import React, { useState } from 'react';
import { Check, ShieldCheck, Lock, Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface BonusItem {
  id: number;
  title: string;
  description: string;
  bullets: string[];
}
const bonuses: BonusItem[] = [{
  id: 1,
  title: '🎁 BONO #1 — Guía de Emergencias Pequeñas',
  description: 'Un imprevisto chiquito NO debería reventarte la quincena ni mandarte a la tarjeta.',
  bullets: ['Protocolo "sin pánico": qué hacer en 2 minutos cuando pasa algo inesperado', 'Regla brutal para no confundir "emergencia" con "antojo con excusa"', 'Cómo reponer tu fondo sin sentir castigo (micro-aportes realistas)']
}, {
  id: 2,
  title: '🎁 BONO #2 — Plan Deuda: Mínimo + Ataque',
  description: 'Si pagas mínimos, sientes que "pagas para nada". Este plan te saca de esa caminadora.',
  bullets: ['Pagas el mínimo en todas (proteges tu estabilidad) + atacas UNA deuda (avance real)', 'Elige estrategia: Bola de Nieve (motivación) o Avalancha (eficiencia)', 'Plantilla ultra simple + checklist para ejecutar desde tu próxima quincena']
}, {
  id: 3,
  title: '🎁 BONO #3 — Guía Express: Cancela Suscripciones Fantasma',
  description: 'Pagos chiquitos automáticos que te drenan sin que te des cuenta (y por eso "no sabes en qué se fue").',
  bullets: ['Auditoría rápida: detectas suscripciones activas y "cobros invisibles"', '3 pasos para cancelar sin vueltas (y sin "después lo hago")', 'Plantilla lista para anotar cuánto recuperas y qué cortas hoy']
}, {
  id: 4,
  title: '🎁 BONO #4 — Reto 72h: Cero Fugas Invisibles',
  description: 'Para cuando dices "la próxima quincena empiezo"… y nunca empiezas. Esto te da tracción en 3 días.',
  bullets: ['Reto simple: 72 horas sin fugas invisibles (sin hacerlo perfecto)', 'Checklist diario + mini-acciones para no sabotearte', 'Resultado: control rápido + vuelves a sentirte capaz de sostener el sistema']
}, {
  id: 5,
  title: '🎁 BONO #5 — Kit "Vida Variable" (límites suaves)',
  description: 'Lo variable es lo que te roba la quincena: tiendita, antojos, domicilios, transporte… "poquitos" que te dejan en cero.',
  bullets: ['Topes humanos por 3–5 categorías (sin Excel, sin prohibirte la vida)', 'Incluye "sí permitido" para gastar sin culpa y sin rebote', 'Plan B + 3 formas fáciles de trackear (notas, fichas o sobres)']
}];
export function Offer() {
  const [openBonus, setOpenBonus] = useState<number | null>(null);
  const toggleBonus = (id: number) => {
    setOpenBonus(openBonus === id ? null : id);
  };
  return <section id="offer" className="py-12 bg-brand-dark relative overflow-hidden" data-id="element-108">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-109">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-green rounded-full blur-3xl" data-id="element-110"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-111"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-112">
        <div className="max-w-6xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-113">
          <div className="bg-brand-gold py-3 text-center" data-id="element-114">
            <p className="font-heading font-bold text-brand-dark text-sm uppercase tracking-wider" data-id="element-115">
              Oferta Especial • Acceso Inmediato
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-116">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-brand-dark mb-2" data-id="element-117">
              Empieza hoy
            </h2>
            <p className="text-brand-text/70 mb-8" data-id="element-118">
              Funciona aunque odies presupuestar
            </p>

            {/* Product Image */}
            <div className="mb-8" data-id="element-119">
              <img src="https://cdn.magicpatterns.com/uploads/aYWWG4Hzj3mftfQYm7nrJa/Mockup_Producto_Principal.png" alt="Quincena en Verde - Mockup del producto" className="w-full max-w-2xl mx-auto rounded-xl shadow-lg" data-id="element-120" />
            </div>

            <div className="flex items-center justify-center gap-4 mb-6" data-id="element-121">
              <span className="text-6xl font-heading font-bold text-brand-green" data-id="element-122">
                $8.97
              </span>
              <div className="text-left" data-id="element-123">
                <span className="block text-brand-text font-bold" data-id="element-124">USD</span>
                <span className="block text-sm text-brand-text/60 line-through" data-id="element-125">
                  $27.00
                </span>
              </div>
            </div>

            {/* Key Features List */}
            <div className="mb-8 max-w-md mx-auto" data-id="element-126">
              <ul className="space-y-3 text-left" data-id="element-127">
                <motion.li animate={{
                scale: [1, 1.05, 1],
                opacity: [0.8, 1, 0.8]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="flex items-center justify-center text-brand-dark" data-id="element-128">
                  <span className="font-sans text-base md:text-lg leading-relaxed font-semibold" data-id="element-129">
                    Pago único • Sin suscripciones
                  </span>
                </motion.li>
                <li className="flex items-start gap-3 text-brand-dark" data-id="element-130">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-green/10 flex items-center justify-center mt-0.5" data-id="element-131">
                    <Check className="w-4 h-4 text-brand-green" strokeWidth={3} data-id="element-132" />
                  </div>
                  <span className="font-sans text-sm md:text-base leading-relaxed" data-id="element-133">
                    Acceso instantáneo al ebook completo
                  </span>
                </li>
                <li className="flex items-start gap-3 text-brand-dark" data-id="element-134">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-green/10 flex items-center justify-center mt-0.5" data-id="element-135">
                    <Check className="w-4 h-4 text-brand-green" strokeWidth={3} data-id="element-136" />
                  </div>
                  <span className="font-sans text-sm md:text-base leading-relaxed" data-id="element-137">
                    Plan de 7 días paso a paso
                  </span>
                </li>
                <li className="flex items-start gap-3 text-brand-dark" data-id="element-138">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-green/10 flex items-center justify-center mt-0.5" data-id="element-139">
                    <Check className="w-4 h-4 text-brand-green" strokeWidth={3} data-id="element-140" />
                  </div>
                  <span className="font-sans text-sm md:text-base leading-relaxed" data-id="element-141">
                    Plantillas descargables
                  </span>
                </li>
                <li className="flex items-start gap-3 text-brand-dark" data-id="element-142">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-green/10 flex items-center justify-center mt-0.5" data-id="element-143">
                    <Check className="w-4 h-4 text-brand-green" strokeWidth={3} data-id="element-144" />
                  </div>
                  <span className="font-sans text-sm md:text-base leading-relaxed" data-id="element-145">
                    Compatible con móvil, tablet y computadora
                  </span>
                </li>
                <li className="flex items-start gap-3 text-brand-dark" data-id="element-146">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-green/10 flex items-center justify-center mt-0.5" data-id="element-147">
                    <Check className="w-4 h-4 text-brand-green" strokeWidth={3} data-id="element-148" />
                  </div>
                  <span className="font-sans text-sm md:text-base leading-relaxed" data-id="element-149">
                    Sin suscripciones ni cargos ocultos
                  </span>
                </li>
              </ul>
            </div>

            {/* Bonuses Accordion Section */}
            <div className="mb-8 bg-gradient-to-br from-brand-green to-brand-dark p-8 md:p-10 rounded-2xl -mx-4 md:-mx-8" data-id="element-150">
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-151">
                +5 Bonos de regalo (incluidos hoy)
              </h3>

              <img src="https://cdn.magicpatterns.com/uploads/b59a6oqXqLmeCboZrkuQR2/Quincena_en_Verde.png" alt="5 Bonos incluidos" className="w-full max-w-3xl mx-auto rounded-xl mb-4" data-id="element-152" />

              <motion.p animate={{
              y: [0, -5, 0],
              opacity: [0.9, 1, 0.9]
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="text-white text-base md:text-lg mb-6 text-center" data-id="element-153">
                Toca para ver lo que incluye 👇
              </motion.p>

              <div className="space-y-3" data-id="element-154">
                {bonuses.map(bonus => <div key={bonus.id} className="bg-brand-cream/95 rounded-2xl border-2 border-brand-green/30 overflow-hidden shadow-md" data-id="element-155">
                    <button onClick={() => toggleBonus(bonus.id)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-brand-cream transition-colors" aria-expanded={openBonus === bonus.id} data-id="element-156">
                      <span className="font-heading font-bold text-brand-dark text-base md:text-lg pr-4" data-id="element-157">
                        {bonus.title}
                      </span>
                      <div className={`flex-shrink-0 w-8 h-8 rounded-full border-2 border-brand-gold bg-white flex items-center justify-center transition-transform duration-300 ${openBonus === bonus.id ? 'rotate-180' : ''}`} data-id="element-158">
                        {openBonus === bonus.id ? <Minus className="w-4 h-4 text-brand-gold" strokeWidth={3} data-id="element-159" /> : <Plus className="w-4 h-4 text-brand-gold" strokeWidth={3} data-id="element-160" />}
                      </div>
                    </button>

                    <AnimatePresence initial={false} data-id="element-161">
                      {openBonus === bonus.id && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.3,
                    ease: 'easeInOut'
                  }} className="overflow-hidden" data-id="element-162">
                          <div className="px-5 md:px-6 pb-5 md:pb-6 pt-2 border-t border-brand-green/10" data-id="element-163">
                            <p className="font-sans text-brand-dark text-base md:text-lg mb-4 leading-relaxed" data-id="element-164">
                              {bonus.description}
                            </p>
                            <ul className="space-y-2.5" data-id="element-165">
                              {bonus.bullets.map((bullet, idx) => <li key={idx} className="flex items-start gap-3 text-left" data-id="element-166">
                                  <span className="text-brand-gold mt-1 flex-shrink-0 text-lg" data-id="element-167">
                                    •
                                  </span>
                                  <span className="font-sans text-brand-dark/90 text-sm md:text-base leading-relaxed" data-id="element-168">
                                    {bullet}
                                  </span>
                                </li>)}
                            </ul>
                          </div>
                        </motion.div>}
                    </AnimatePresence>
                  </div>)}
              </div>
            </div>

            <a href="https://pay.hotmart.com/I103403400D" target="_blank" rel="noopener noreferrer" className="w-full max-w-md bg-brand-green hover:bg-brand-dark text-white font-heading font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:scale-[1.02] text-xl mb-4 inline-block text-center" data-id="element-169">
              Sí, lo quiero
            </a>

            <div className="flex items-center justify-center gap-4 text-sm text-brand-text/60 mb-8" data-id="element-170">
              <span className="flex items-center gap-1" data-id="element-171">
                <Lock className="w-3 h-3" data-id="element-172" /> Pago seguro
              </span>
              <span className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-173"></span>
              <span data-id="element-174">Descarga inmediata</span>
            </div>

            <div className="bg-brand-cream/50 p-6 rounded-xl border border-brand-green/10" data-id="element-175">
              <div className="flex items-start gap-3 text-left" data-id="element-176">
                <ShieldCheck className="w-6 h-6 text-brand-green flex-shrink-0 mt-1" data-id="element-177" />
                <div data-id="element-178">
                  <p className="font-heading font-bold text-brand-dark text-sm mb-1" data-id="element-179">
                    Garantía de claridad
                  </p>
                  <p className="font-sans text-sm text-brand-text/80" data-id="element-180">
                    Si no te aporta claridad en los primeros 7 días, escríbenos
                    y lo resolvemos. Sin preguntas incómodas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}